import Components from "../components";

// This component selects a bootstrap tab based on the URL's hash.
// It does not update the URL when the user selects a tab because that
// breaks turbo.
class NavStateful extends Components.Base {
  initialize() {
    if (window.location.hash) {
      this.$el.find(`a[href="${window.location.hash}"]`).tab("show");
    }
  }
}

Components.collection.register({
  selector: ".c-nav-stateful",
  klass: NavStateful,
});
